<template>
    <div class="page-wrap">
        <div style="width:100%">
            <el-row v-if="!isLogged" :gutter="20" type="flex" justify="space-between" align="bottom">
                <el-col :span="12">
                    <h2>{{ $t('auth.register.title') }}</h2>
                </el-col>
                <el-col :span="12" class="text-right">
                    <router-link :to="loginLink" class="blacklink">
                        {{ $t('auth.login.title') }}
                    </router-link>
                </el-col>
            </el-row>
            <el-row v-else :gutter="20" type="flex" justify="space-between" align="bottom">
                <el-col>
                    <h2>Hello{{ currentUserName }}!</h2>
                </el-col>
            </el-row>
            <register-form
                :loading="loading"
                :errors="authErrors"
                @submit="onSubmit"
            />
        </div>
    </div>
</template>

<script>
import RegisterForm from './RegisterForm'
import userApi from '../api'

export default {
    name: 'Register',
    components: {RegisterForm},
    data() {
        return {
            loading: false,
            authErrors: {},
        }
    },
    methods: {
        onSubmit(signUpFormData) {
            this.loading = true;
            if (this.isLogged) {
                userApi.updateUser(signUpFormData).then(r => {
                    if (r && r.data && r.data.success) {
                        this.$message.success('Your information has been updated.');
                    } else {
                        this.$message.error('Please make sure you filed the form correctly, check if the e-mail is already used and try again.')
                        this.authErrors = r.data.errors
                    }
                }).catch((err) => {
                    if (err.response.status === 422)
                        this.authErrors = err.response.data.errors
                }).finally(() => {
                    this.$auth.fetch({});
                    this.loading = false;
                })
            } else {
                userApi.createUser(signUpFormData).then(r => {
                    if (r && r.data && r.data.success) {
                        this.$message.success('Thank you for registering. You can now use your account to login.');
                        this.$router.push(this.loginLink);
                    } else {
                        this.$message.error('Please make sure you filed the form correctly, check if the e-mail is already used and try again.')
                        this.authErrors = r.data.errors
                    }
                }).catch((err) => {
                    if (err.response.status === 422)
                        this.authErrors = err.response.data.errors
                }).finally(() => {
                    this.$auth.fetch({});
                    this.loading = false;
                })
            }
        },
    }
}
</script>

<style lang="scss">

</style>
